export const QUERY_PARAMS_FOR_DEMO = {
  key: "demo",
};
